<div class="guage-container">
  <svg viewBox="0 0 600 120" class="bar-svg" preserveAspectRatio="xMidYMid meet">
    <!-- Block bar -->
    @for (seg of segments; track seg) {
    <g>
      <!-- Block -->
      <rect [attr.x]="seg.x" [attr.y]="seg.y" [attr.width]="seg.w" [attr.height]="seg.h" [attr.fill]="seg.color"
        [attr.opacity]="seg.opacity" rx="3" ry="3" />

      <!-- Top ticks -->
      @for (frac of tickFractions; track frac) {
        <line
          [attr.x1]="seg.x + seg.w * frac"
          [attr.x2]="seg.x + seg.w * frac"
          [attr.y1]="seg.y - seg.h * tickLengthRatio"
          [attr.y2]="seg.y"
          [attr.stroke]="seg.color"
          [attr.opacity]="seg.opacity"
          [attr.stroke-width]="tickStrokeWidth"
          stroke-linecap="round" />
      }

      <!-- Bottom ticks -->
      @for (frac of tickFractions; track frac) {
        <line
          [attr.x1]="seg.x + seg.w * frac"
          [attr.x2]="seg.x + seg.w * frac"
          [attr.y1]="seg.y + seg.h"
          [attr.y2]="seg.y + seg.h + seg.h * tickLengthRatio"
          [attr.stroke]="seg.color"
          [attr.opacity]="seg.opacity"
          [attr.stroke-width]="tickStrokeWidth"
          stroke-linecap="round" />
      }
    </g>
    }


  </svg>
</div>